import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const site: Record<string, any>;

export const composeCognitoUser = (): CognitoUser => {
  const userPool = new CognitoUserPool({
    UserPoolId: site.awsConfig.cognito.userPoolId,
    ClientId: site.awsConfig.cognito.userPoolWebClientId,
    endpoint: site.awsConfig.cognito.endpoint,
  });

  const userData = {
    Username: localStorage.getItem("cognitoUsername"),
    Pool: userPool,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cognitoUser = new CognitoUser(userData) as Record<string, any>;
  cognitoUser.Session = localStorage.getItem("cognitoSession");

  return cognitoUser as CognitoUser;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const storeCognitoInfo = (cognitoUser: Record<string, any>): void => {
  localStorage.setItem("cognitoSession", cognitoUser.Session);
  localStorage.setItem("cognitoUsername", cognitoUser.username);
};

export const removeCognitoInfo = (): void => {
  localStorage.removeItem("cognitoSession");
  localStorage.removeItem("cognitoUsername");
};

export const getCognitoUser = (): CognitoUser => {
  return composeCognitoUser();
};
